var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneRangeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8267 2.21993C14.1683 1.39864 15.3317 1.39864 15.6733 2.21993L18.4169 8.81619C18.5609 9.16242 18.8865 9.39899 19.2603 9.42896L26.3815 9.99987C27.2681 10.0709 27.6277 11.1775 26.9521 11.7561L21.5265 16.4037C21.2417 16.6477 21.1174 17.0305 21.2044 17.3952L22.862 24.3443C23.0684 25.2096 22.1271 25.8934 21.368 25.4298L15.2713 21.7059C14.9512 21.5104 14.5488 21.5104 14.2287 21.7059L8.13199 25.4298C7.37289 25.8934 6.43164 25.2096 6.63803 24.3443L8.29564 17.3952C8.38265 17.0305 8.25828 16.6477 7.97349 16.4037L2.54787 11.7561C1.87233 11.1775 2.23186 10.0709 3.11852 9.99987L10.2397 9.42896C10.6135 9.39899 10.9391 9.16242 11.0831 8.81619L13.8267 2.21993Z",
    fill: "url(#paint0_linear_6421_16386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6421_16386",
    x1: 2.2125,
    y1: 14.75,
    x2: 27.2875,
    y2: 14.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDB022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C8D0DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneRangeStar);
export default __webpack_public_path__ + "static/media/one-range-star.f417f6272a2434a7810c37d0a5f8fe4f.svg";
export { ForwardRef as ReactComponent };